import { render, staticRenderFns } from "./provideDetail.vue?vue&type=template&id=81c2958a&"
import script from "./provideDetail.vue?vue&type=script&lang=js&"
export * from "./provideDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports